module.exports = __webpack_public_path__ + "zilla-slab-latin-400.947db1eb3e48b3798f88ef95afdd2f73.woff";